export interface ApiEnvelope<T> {
  status: string;
  result: T;
  message: string;
}

export interface PaginatedMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  from: number | null;
  to: number | null;
}

export interface PaginatedResult<T> {
  data: T[];
  meta: PaginatedMeta;
  links?: unknown;
}

export function unwrapResult<T>(payload: ApiEnvelope<T> | undefined): T | null {
  return payload?.result ?? null;
}

export function unwrapData<T>(
  payload: ApiEnvelope<{ data: T }> | undefined
): T | null {
  return payload?.result?.data ?? null;
}

export function unwrapList<T>(
  payload: ApiEnvelope<PaginatedResult<T>> | undefined
): PaginatedResult<T> {
  return (
    payload?.result ?? {
      data: [],
      meta: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
        from: null,
        to: null,
      },
      links: [],
    }
  );
}

